import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
// @ts-ignore
import { template_manager, user_access, folder_manager, system_manager } from '../assets/conf_urls.json';
import { MatSnackBar } from '@angular/material/snack-bar';

import { MatTableDataSource } from '@angular/material/table';
import { createReturn } from 'typescript';
import { isObject } from 'rxjs/internal/util/isObject';
import { AuthService } from '../app/services/auth.service';
import jwt_decode from 'jwt-decode'
import { stringify } from '@angular/compiler/src/util';
import { consoleTestResultHandler } from 'tslint/lib/test';
import { LoggerService } from 'src/shared/logger/logger.service';
import { Levels } from 'src/shared/logger/levels.enum';
import { SearchModuleService } from 'src/shared/search.module.service';

export interface CommandsGroup {

  CommandFamily: string;
  CommandName: string[];
  id: string[];
  software_id: string[];
  CommandType: string[];
  CommandSyntax: string[];


}

export interface IMappingCommands {
  event: "create_template_conf",
  added_by: string
  command_syntax: string,
  command_value: any,
  command_type: any,
  command_sw_version: any,
  command_sw_version_text: any,
  command_family: any,
  template_name_id: any,
  command_id_fk: any,
  command_is_enabled: 1
};

export const _filter = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();

  return opt.filter(item => item.toLowerCase().indexOf(filterValue) === 0);
};

@Component({
  selector: 'app-template-manager',
  templateUrl: './template-manager.component.html',
  styleUrls: ['./template-manager.component.css']
})
export class TemplateManagerComponent implements OnInit {
  //
  newTemplateForm: FormGroup;
  mapCommandsForm: FormGroup;
  createJobForm: FormGroup;
  updateJobForm: FormGroup;
  modal_modifyCommandConfForm: FormGroup;
  dateTimeExample;
  panelOpenState = false;
  show_progressbar = false;
  // stepper:
  // templates selection
  distinct_templates: any
  template_name: any;
  template_id: any;

  //
  //commands form
  distinct_software_name: any
  filter_sw_version: any
  selected_commands_list: IMappingCommands[] = []
  saved_commands_list = []
  //create a job
  created_job_id: any;
  list_of_job_selected_folders = []
  list_of_job_selected_systems = []
  creation_finished = false
  slider_addmore = false
  slider_addmore_commands = false
  slider_editcurrent_commands = false
  slider_editcurrent_job = false

  //end
  //profile
  target_folder_list = []
  target_systems_list = []
  modal_edit_command_conf = []
  //

  //messaging vars
  //configuration => history job on click to get the logs.
  selected_item_job_id = ""
  selected_item_template_id = ""
  selected_item_job_row: any
  switcher_deletecommand = false
  show_delete_job = false
  selected_item_job_id_history = ""
  selected_sql_row = {}

  //

  //for user access
  user_permission;
  user_email = localStorage.getItem('useremail');

  stateGroups = [];

  SoftwareVersion = new FormControl();
  stateForm: FormGroup = this._formBuilder.group({
    stateGroup: '',
  });

  stateGroupOptions: Observable<CommandsGroup[]>;

  user_access_obj = ['admin', 'operator']
  //user_info = stringify(jwt_decode(localStorage.getItem('accessToken')))
  user_info_obj;
  sort_template_tree_by = "template_jobs"
  sort_nav_tree_by = "folder"
  sort_by_list = [
    { value: 'folder', viewValue: 'Folder' },
    { value: 'software_name', viewValue: 'Software Name' },
    { value: 'software_version', viewValue: 'Software Version' },
    { value: 'product_id', viewValue: 'Product Id' }
  ];
  displayedColumns = ["deleteIcon", "name"];
  recieve_selected_items = [];
  addNewTemplate: boolean = false;

  public utctimenow = new Date().toUTCString()

  constructor(private _snackBar: MatSnackBar,
    private _formBuilder: FormBuilder,
    private http: HttpClient,
    private authService: AuthService,
    private loggerService: LoggerService,
    private searchModuleService: SearchModuleService) {
    setInterval(() => {
      this.utctimenow = new Date().toUTCString();
    }, 1);
  }

  ngOnInit(): void {
    this.searchModuleService.dataTransmitted.subscribe(data =>
      this.recieve_selected_multiple_items(data)
    );
    if (localStorage.getItem('accessToken')) {
      this.user_info_obj = jwt_decode(localStorage.getItem('accessToken'))
    }
    this.stateGroupOptions = this.stateForm.get('stateGroup')!.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filterGroup(value))
      );


    this.get_distinct_templates();
    this.get_distinct_software_CommandDisplayName();

    this.newTemplateForm = this._formBuilder.group({
      template_name: ['', Validators.required],
      template_description: ['', Validators.required]
    });

    this.mapCommandsForm = this._formBuilder.group({});

    this.createJobForm = this._formBuilder.group({
      job_title: ['', Validators.required],
      start_job_at: ['', Validators.required],
      template_frequency: ['', Validators.required],
      template_display_name_id: [''],
      event: ['create_template_job'],
      template_job_id: [''],
      next_run_time: ['']

    });
    this.updateJobForm = this._formBuilder.group({
      job_title: ['', Validators.required],
      start_job_at: ['', Validators.required],
      template_frequency: ['', Validators.required],

      event: ['update_template_profile_id'],


    });
    this.modal_modifyCommandConfForm = this._formBuilder.group({});

  }

  click_get_conf_button() {

    setTimeout(() => {
      try {
        let element: HTMLElement = document.getElementsByClassName('mat-focus-indicator m-1 mat-raised-button mat-button-base mat-primary ng-star-inserted')[0] as HTMLElement;
        element.click();

      } catch (error) {

      }



    }, 700)
  }
  reload_treeView() {

    setTimeout(() => {
      try {
        let element: HTMLElement = document.getElementsByClassName('nav-link')[0] as HTMLElement;
        let element1: HTMLElement = document.getElementsByClassName('nav-link')[1] as HTMLElement;
        element.click();
        element1.click();
      } catch (error) {

      }
    }, 700)
  }

  reload_treeView1() {

    setTimeout(() => {
      let element: HTMLElement = document.getElementsByClassName('nav-link')[1] as HTMLElement;
      element.click();

    }, 700)
  }

  // for user access
  get_user_access_service(useremail: any) {
    useremail = useremail.trim();

    localStorage.setItem('useremail', useremail);
    var json_object = { 'user_email': useremail };
    this.http.post(user_access.url, json_object).subscribe(data => {

      if (data.toString().length > 0) {
        //if user active
        if (data[0]['is_active'] == 'y') {
          var useraccess = data[0]['user_permission'];
          localStorage.setItem('ua', useraccess);
          //create a session
          //end
          // window.location.href = '/home';
        }
        //if user not active
        if (data[0]['is_active'] == 'n') {
          window.location.href = '/newaccess';
        }
      }

    }
    );
    //  end
  }



  recieve_selected_multiple_items(items: any) {
    this.recieve_selected_items = items
    // items.forEach(item => {
    //   if (item["parent"]) {
    //     delete item["parent"]
    //   }
    // });

  }
  recieve_selected_multiple_items_commands(items: any) {
    this.recieve_selected_items = items
    items.forEach(item => {
      if (item["parent"]) {
        delete item["parent"]
      }
    });
  }

  move_selected_to_list() {

    this.show_progressbar = true
    //this.stateGroups = this.stateGroups.concat(this.recieve_selected_items)
    this.recieve_selected_items.forEach(item => {
      if (this.stateGroups.find(element => element.id == item["id"])) {
        return
      }
      this.stateGroups.push(item)
    })
    this.recieve_selected_items = []
    this.show_progressbar = false
  }

  move_selected_systems_to_task_list() {
    this.show_progressbar = true
    let request_body = {
      "event": "select_by_id_list", "id_list": this.recieve_selected_items
    }
    this.http.post(system_manager.services, request_body).subscribe(response_data => {

      if (response_data["status_type"] == "Success") {
        //found system profile
        if (response_data["data"][0]) {
          response_data["data"].forEach(item => {
            this.move_single_system_to_list(item)
          });
          this.show_progressbar = false

        }
        //no data for this mac address
        else {
          //change the message only
          this.show_progressbar = false;
        }
      } else {
        this.show_progressbar = false;
      }
    }, err => {
      this.loggerService.log("TemplateManagerComponent", err.message, Levels.error)
    })

    this.recieve_selected_items = []
  }

  move_single_system_to_list(system_obj) {
    if (this.list_of_job_selected_systems.find(element => element.id == system_obj["id"])) {
      return
    }
    this.list_of_job_selected_systems.push(system_obj);
    if (this.target_systems_list.find(element => element.id == system_obj["id"])) {
      return
    }
    this.target_systems_list.push(system_obj);
    //  2. create the upgrade list item

  }



  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 8000,
      panelClass: ['mat-toolbar', 'mat-primary']
    });

  }

  get_distinct_templates() {
    this.http.post(template_manager.services, { "event": "query_distinct_templates" }).subscribe(response_data => {
      this.distinct_templates = response_data["data"];
    })
  }

  get_distinct_software_CommandDisplayName() {
    this.http.post(template_manager.services, { "event": "query_distinct_sw_version" }).subscribe(response_data => {
      this.distinct_software_name = response_data["data"];
    })
  }

  //first form : stepper save template
  onCheck_assign_id(row: any) {
    this.template_name = row["template_name"]
    this.template_id = row["id"]
    this.http.post(template_manager.services, { "event": "query_template_assigned_commands", "template_id": this.template_id }).subscribe(response_data => {
      this.stateGroups = response_data["data"]

    }, err => {
      this.loggerService.log("TemplateManagerComponent", err.message, Levels.error)

    })
  }

  ngOnsubmit_save_new_template() {
    if (this.newTemplateForm.valid) {
      this.newTemplateForm.value["event"] = "create_template_profile"
      this.http.post(template_manager.services, this.newTemplateForm.value).subscribe(response_data => {
        if (response_data["status"] == 'success') {
          this.openSnackBar(response_data["message"], response_data["status"])
          this.template_id = response_data["data"];
          this.get_distinct_templates();
          this.addNewTemplate = false;
        } else {
          this.openSnackBar(response_data["message"], response_data["status"])
        }
      }, err => {
        this.loggerService.log("TemplateManagerComponent", err.message, Levels.error)
      })
    }
  }

  //end
  //second form: stepper commnad mapper
  getCommands_by_filter(id: any) {
    var req_body = { "event": "query_commands_by_software_version", "id": id }
    this.http.post(template_manager.services, req_body).subscribe(data => {

    }, err => {
      this.loggerService.log("TemplateManagerComponent", err.message, Levels.error)
    })

  }

  filter_sw_version_event(id: any) {
    this.filter_sw_version = id

  }

  get_template_saved_commnads() {
    let j = {
      "event": "query_template_conf_id",
      "id": this.selected_item_job_id
    }
    this.http.post(template_manager.services, j).subscribe(data => {
      this.saved_commands_list = data["data"]
    }, err => {
      this.loggerService.log("TemplateManagerComponent", err.message, Levels.error)
    })
  }

  add_selected_command_to_list(id, sw_id, command_syntax, command_type, command_name) {


    let json = { "event": "query_choices_by_command_id", "id": id }
    // this is to get command choices
    this.http.post(template_manager.services, json).subscribe(response_data => {
      // $event["options"] = response_data["data"]
    })


    const fc = new FormControl(command_syntax, Validators.required);
    this.mapCommandsForm.addControl('command_syntax_' + id, fc)

    const fk = new FormControl(id, Validators.required);
    this.mapCommandsForm.addControl('fk_' + id, fk)

    const fcv = new FormControl('', Validators.required);
    this.mapCommandsForm.addControl('command_value_' + id, fcv)
    const fc_sw = new FormControl(sw_id, Validators.required);
    this.mapCommandsForm.addControl('sw_' + id, fc_sw)
    const fc_command_type = new FormControl(command_type, Validators.required);
    this.mapCommandsForm.addControl('type_' + id, fc_command_type)
    const template_name_id = new FormControl(this.template_id, Validators.required);
    this.mapCommandsForm.addControl('template_' + id, template_name_id)
    //
    Object.keys(this.selected_commands_list).forEach(item => {
      let item_id = this.selected_commands_list[item]["item"]["props"]["id"]
      if (id == item_id) {
        this.selected_commands_list.splice(parseInt(item), 1)
      }

    })

    // this.selected_commands_list.push($event)
    this.openSnackBar("Command was added to the list", "success")
  }


  //end
  delete_from_list(item: any) {

  }

  assign_commands_to_template(commands_arr: any) {
    let template_name_id = null
    if (template_name_id == undefined || template_name_id == null) {
      template_name_id = this.selected_item_template_id
    }
    // if (command_type == 'text') {
    //   command_value = '"' + command_value + '"'
    // }

    if (commands_arr) {

      let jobj = {
        "event": "create_template_conf",
        "template_name_id": this.template_id,
        "commands_arr": commands_arr
        // "added_by": added_by,
        // "command_syntax": command_syntax,
        // "command_value": command_value,
        // "command_sw_version": command_sw,
        // "command_id_fk": command_id,
        // "command_is_enabled": 1
      }
      //post command to the template
      this.show_progressbar = true
      this.http.post(template_manager.services, jobj).subscribe(response_data => {
        if (response_data["status"] == "success") {
          this.show_progressbar = false
          this.openSnackBar(response_data["message"], response_data["status"])
        } else {
          this.show_progressbar = false
          this.openSnackBar(response_data["message"], response_data["status"])

        }
      })
    } else {
      this.openSnackBar("Commands list is empty", "Pending")
    }
  }


  //


  create_template_job() {


    var d = new Date();
    var year = d.getFullYear();
    var month = d.getMonth();
    var day = d.getDate();
    var c = new Date(year + 30, month, day);

    if (this.template_id == undefined) {
      this.openSnackBar("Please select/create a template first", "Error")
      return
    }
    // if (!this.createJobForm.value["job_title"].includes('@')) {

    //   this.createJobForm.value["job_title"] = this.createJobForm.value["job_title"] + " @" + localStorage.getItem('useremail').split('@')[0]
    // }

    this.createJobForm.value["template_display_name_id"] = this.template_id
    this.createJobForm.value["template_job_id"] = this.uuidv4()
    this.createJobForm.value["next_run_time"] = this.createJobForm.value["start_job_at"]
    this.createJobForm.value["start_expires_at"] = c
    if (this.createJobForm.valid) {
      this.http.post(template_manager.services, this.createJobForm.value).subscribe(response_data => {
        if (response_data["status"] == 'success') {
          this.openSnackBar(response_data["message"], response_data["status"])
          this.created_job_id = response_data['data']
        } else {

          this.openSnackBar(response_data["message"], response_data["status"])
        }
      }, err => {
        this.loggerService.log("TemplateManagerComponent", err.message, Levels.error)
      })
    }
  }

  uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  tree_recieve_selected_item($event) {

    if ($event["expandable"] == false) {
      let switch_case = 0
      let entered_system_name = $event['item']['name']
      Object.keys(this.list_of_job_selected_systems).forEach(index => {
        let row_system_name = this.list_of_job_selected_systems[index]['item']['name']
        if (row_system_name == entered_system_name) {
          switch_case = 1
          return
        }
      })
      if (switch_case == 0) {
        this.list_of_job_selected_systems.push($event)
        this.openSnackBar(entered_system_name + " was added to the list.", 'Success')
      } else {

        this.openSnackBar(entered_system_name + " is already in the list.", 'Warning')

      }
    } else {
      let switch_case = 0
      let entered_folder_name = $event['item_name']
      Object.keys(this.list_of_job_selected_folders).forEach(index => {
        let row_folder_name = this.list_of_job_selected_folders[index]['item_name']
        if (row_folder_name == entered_folder_name) {
          switch_case = 1
          return
        }
      })
      if (switch_case == 0) {
        this.list_of_job_selected_folders.push($event)
        this.openSnackBar(entered_folder_name + " was added to the list.", 'Success')
      } else {

        this.openSnackBar(entered_folder_name + " is already in the list.", 'Warning')

      }


    }
  }

  set_template_job_id($event) {
    this.selected_item_job_row = $event
    this.selected_item_job_id_history = $event["value"]["id"]
    this.selected_item_template_id = $event["value"]["parent"]["value"]["id"]
    this.get_job_target_list($event["value"]["id"])
    this.get_template_saved_commnads()

  }

  get_job_target_list(id: any) {
    this.target_folder_list = []
    this.target_systems_list = []
    this.selected_item_job_id = id
    let j = {
      "event": "query_conf_by_job_id",
      "id": id

    }
    this.http.post(template_manager.services, j).subscribe(response_data => {
      if (response_data["status"] == "success") {
        //this.target_folder_list = response_data["data"][0]["folders"]
        this.target_systems_list = response_data["data"]["systems"]
        this.show_progressbar = false
        this.openSnackBar(response_data["message"], response_data["status"])

      } else {
        this.show_progressbar = false
        this.openSnackBar(response_data["message"], response_data["status"])

      }

    })
  }

  assign_items_to_job() {
    let jobject = {
        "event": "create_job_system_conf",
        "systeminformation_id_list": this.recieve_selected_items,
        "templatecreatejob_id": this.created_job_id,

      }
      this.http.post(template_manager.services, jobject).subscribe(data => {
        if (data["status"] == 'success') {
          this.openSnackBar(data["message"], data["status"])

        } else {
          this.openSnackBar(data["message"], data["status"])

        }
      }, err => {
        this.loggerService.log("TemplateManagerComponent", err.message, Levels.error)
      })
    this.creation_finished = true
  }

  add_item_to_current_list($event) {


    // event validation
    let item = $event['item']
    let item_type = $event['expandable']
    if ($event['item_name'] !== undefined) {
      // define the item type

      // item is a folder

      // check the item in the list
      let switch_case = 0
      Object.keys(this.target_folder_list).forEach(index => {
        let current_item_name = this.target_folder_list[index]['item_name']
        let selected_item_name = $event['item_name']
        // validate
        if (current_item_name == selected_item_name) {
          // item was found
          switch_case = 1
        }
      })
      // check if the folder was found or not
      if (switch_case == 0) {
        this.target_folder_list.push($event)
        this.openSnackBar($event['item_name'] + " was added to the list.", 'Success')
      }
      else {
        this.openSnackBar($event['item_name'] + " is already in the list.", 'Warning')
      }

    }
    // item validated with type
    if (item !== undefined && item_type !== undefined) {


      // item is a system
      // check the item in the list
      let switch_case = 0
      Object.keys(this.target_systems_list).forEach(index => {
        let current_item_name = this.target_systems_list[index]['system_name']
        let selected_item_name = item['system_name']
        // validate
        if (current_item_name == selected_item_name) {
          // item was found
          switch_case = 1
        }
      })
      // check if the system was found or not
      if (switch_case == 0) {
        this.target_systems_list.push(item)
        this.openSnackBar(item['system_name'] + " was added to the list.", 'Success')
      }
      else {
        this.openSnackBar(item['system_name'] + " is already in the list.", 'Warning')
      }


    }


  }

  //sql table

  get_selected_sql_row($event) {
    this.modal_modifyCommandConfForm = this._formBuilder.group({});
    this.show_progressbar = true;
    let command_id = $event['command_id']
    let command_conf_id = $event['command_conf_id']
    let value_type = $event['command_parameters_count']
    var jobject = {
      "event": "query_command_configuration",
      "id": command_id
    }
    this.http.post(template_manager.services, jobject).subscribe(response_data => {
      if (response_data["status"] == "success") {
        this.show_progressbar = false
        this.modal_edit_command_conf = response_data["data"]
        //add mandatory form controls
        const command_conf_id_ctrl = new FormControl(command_conf_id, Validators.required);
        this.modal_modifyCommandConfForm.addControl('id', command_conf_id_ctrl)

        const command_value = new FormControl('');
        this.modal_modifyCommandConfForm.addControl('command_value', command_value)

        let value_type = this.modal_edit_command_conf[0]['command_props']['command_parameters_count']
        const command_value_type = new FormControl(value_type, Validators.required);
        this.modal_modifyCommandConfForm.addControl('command_value_type', command_value_type)

      } else {
        this.show_progressbar = false

      }
    }, err => {
      this.loggerService.log("TemplateManagerComponent", err.message, Levels.error)
    })
    this.selected_sql_row = $event
    $("#modal_sql_row").click()
  }


  delete_folder_from_current_list(item: any) {
    this.target_folder_list.forEach(folder => {
      let folder_id = folder["id"]
      let rem_folder_id = item["id"]
      if (folder_id == rem_folder_id) {
        let index = this.target_folder_list.indexOf(folder)
        this.target_folder_list.splice(index, 1);
        this.openSnackBar("Folder " + item["item_name"] + " was removed", "success")
      }

    })


  }

  delete_system_from_current_list(item: any) {
    let index = 0
    this.target_systems_list.forEach(system => {
      index += 1

      let system_id;
      let rem_system_id;
      if (system["id"] !== undefined) {
        system_id = system["id"]
      }
      else {
        system_id = system['item']["id"]
      }
      if (item["id"] !== undefined) {
        rem_system_id = item["id"]
      }
      else {
        rem_system_id = item['item']["id"]
      }


      if (system_id == rem_system_id && (system_id != undefined || rem_system_id != undefined)) {
        // let index = this.target_folder_list.indexOf(system)
        if (index == 0) {
          this.target_systems_list.splice(index, 1);
        }
        else {
          this.target_systems_list.splice(index - 1, 1);
        }


        this.openSnackBar("System " + item["system_name"] + " was removed", "success")
      }

    })

  }

  delete_template_command_conf(item_id: any) {
    //delete_template_conf_id
    if (item_id !== undefined) {
      this.show_progressbar = true
      let jobject = {
        "event": "delete_template_conf_id",
        "id": item_id
      }
      this.http.post(template_manager.services, jobject).subscribe(response_data => {
        if (response_data["status"] == "success") {
          this.show_progressbar = false
          this.openSnackBar(response_data["message"], response_data["status"])

        } else {
          this.show_progressbar = false
          this.openSnackBar(response_data["message"], response_data["status"])

        }
      }, err => {
        this.loggerService.log("TemplateManagerComponent", err.message, Levels.error)
      })
    }

  }

  delete_job() {
    var job = {
      "event": "delete_job_by_template_job_id",
      "id": this.selected_item_job_id_history
    }

    this.http.post(template_manager.services, job).subscribe(response_data => {
      if (response_data["status"] == 'success') {
        this.openSnackBar(response_data["message"], response_data["status"])
        document.getElementById('refreshID').click();

      } else {
        this.openSnackBar(response_data["message"], response_data["status"])
        this.loggerService.log("TemplateManagerComponent", response_data["message"], Levels.error)
      }

    }, err => {
      this.loggerService.log("TemplateManagerComponent", err.message, Levels.error)
    })
  }

  ngSubmit_save_job_config_folder_changes() {
    //user cleared all folders.
    var jobject = {
      "event": "clear_jobs_folders",
      "templatecreatejob_id": this.selected_item_job_id
    }
    this.http.post(template_manager.services, jobject).subscribe(response_data => {
      if (response_data["status"] == "success") {
        this.show_progressbar = false
        this.openSnackBar(response_data["message"], response_data["status"])

      } else {
        this.show_progressbar = false
        this.openSnackBar(response_data["message"], response_data["status"])

      }
    })

    if (this.target_folder_list.length == 0) {
      this.show_progressbar = true
      var jobject = {
        "event": "clear_jobs_folders",
        "templatecreatejob_id": this.selected_item_job_id
      }
      this.http.post(template_manager.services, jobject).subscribe(response_data => {
        if (response_data["status"] == "success") {
          this.show_progressbar = false
          this.openSnackBar(response_data["message"], response_data["status"])

        } else {
          this.show_progressbar = false
          this.openSnackBar(response_data["message"], response_data["status"])

        }
      })
    }
    if (this.target_folder_list.length > 0) {
      this.target_folder_list.forEach(item => {
        let folder_id = item["id"]
        let jobject = {
          "event": "create_job_folder_conf",
          "templatecreatejob_id": this.selected_item_job_id,
          "systemlocation_id": folder_id

        }
        this.http.post(template_manager.services, jobject).subscribe(response_data => {
          if (response_data["status"] == "success") {
            this.show_progressbar = false
            this.openSnackBar(response_data["message"], response_data["status"])

          } else {
            this.show_progressbar = false
            this.openSnackBar(response_data["message"], response_data["status"])

          }
        })
      })
    }

  }

  ngSubmit_update_job_profile() {
    if (this.updateJobForm.valid) {
      this.updateJobForm.value["id"] = this.selected_item_job_id_history
      this.updateJobForm.value["next_run_time"] = this.updateJobForm.value["start_job_at"]
      this.updateJobForm.value["job_creator_editor"] = this.user_info_obj["name"]
      this.http.post(template_manager.services, this.updateJobForm.value).subscribe(response_data => {
        if (response_data["status"] == 'success') {
          this.openSnackBar(response_data["message"], response_data["status"]);
          document.getElementById('refreshID').click();
          this.slider_editcurrent_job = false;
          this.selected_item_job_row = null;
        } else {
          this.openSnackBar(response_data["message"], response_data["status"]);
        }
      }, err => {
        this.loggerService.log("TemplateManagerComponent", err.message, Levels.error);
      })
    }
  }

  ngSubmit_save_job_config_system_changes() {

    //  user cleared all systems.
    if (this.recieve_selected_items.length == 0) {
      this.show_progressbar = true
      var jobject = {
        "event": "clear_jobs_systems",
        "templatecreatejob_id": this.selected_item_job_id
      }
      this.http.post(template_manager.services, jobject).subscribe(response_data => {
        if (response_data["status"] == "success") {
          this.show_progressbar = false
          this.openSnackBar(response_data["message"], response_data["status"])
          this.recieve_selected_items = []
          this.get_job_target_list(this.selected_item_job_id_history)

        } else {
          this.show_progressbar = false
          this.openSnackBar(response_data["message"], response_data["status"])

        }
      }, err => {
        this.loggerService.log("TemplateManagerComponent", err.message, Levels.error)
      })
    }
    else if (this.recieve_selected_items.length > 0) {

        let jobject = {
          "event": "create_job_system_conf",
          "templatecreatejob_id": this.selected_item_job_id,
          "systeminformation_id_list": this.recieve_selected_items

        }
        this.http.post(template_manager.services, jobject).subscribe(response_data => {
          if (response_data["status"] == "success") {
            this.show_progressbar = false
            this.openSnackBar(response_data["message"], response_data["status"])
            this.recieve_selected_items = []
            this.get_job_target_list(this.selected_item_job_id_history)

          } else {
            this.show_progressbar = false
            this.openSnackBar(response_data["message"], response_data["status"])

          }
        }, err => {
          this.loggerService.log("TemplateManagerComponent", err.message, Levels.error)
        })
    }

  }

  ngSubmit_save_modified_template_command() {

    if (this.modal_modifyCommandConfForm.valid) {
      this.modal_modifyCommandConfForm.value["event"] = "update_template_conf_id"
      if (this.modal_modifyCommandConfForm.value["command_value_type"] == 'text') {
        this.modal_modifyCommandConfForm.value["command_value"] = '"' + this.modal_modifyCommandConfForm.value["command_value"] + '"'
      }
      delete this.modal_modifyCommandConfForm.value["command_value_type"]
      this.http.post(template_manager.services, this.modal_modifyCommandConfForm.value).subscribe(response_data => {
        if (response_data["status"] == 'success') {
          this.openSnackBar(response_data["message"], response_data["status"])


        } else {
          this.openSnackBar(response_data["message"], response_data["status"])

        }

      }, err => {
        this.loggerService.log("TemplateManagerComponent", err.message, Levels.error)
      })
    }

  }

  //commands controller
  check_all() {
    document.querySelectorAll<HTMLElement>('.mat-option').forEach(item => {
      var select_state = item.getAttribute('aria-selected')

      if (select_state === 'false') {
        item.click()
      }
    })
  }

  deselect_all() {
    document.querySelectorAll<HTMLElement>('.mat-option').forEach(item => {
      var select_state = item.getAttribute('aria-selected')
      if (select_state === 'true') {
        item.click()
      }
    })

  }


  get_filtered_commands() {
    this.show_progressbar = true
    this.stateGroups = []
    var selectedList_sw_versions = this.SoftwareVersion.value
    var search_key = this.stateForm.get('stateGroup').value
    var ob = {
      "parent_table_name": "system_overview_systemclicommands",
      "parent_table_group_key": "command_family",
      "parent_table_display_value": "command_display_name",
      "software_filter_list": selectedList_sw_versions,
      "search_keyword": search_key
    }

    var array = []
    this.http.post(template_manager.templatecommandsview, ob).subscribe(data => {
      this.show_progressbar = false
      this.stateGroups = data['tree'][0]
      if (this.stateGroups === undefined) {
        this.openSnackBar('No results found,try another keyword', '')

      }

    })
  }

  toggle_command_parameter_div($event, line) {
    var parameter_element_id = "command_value_" + line['id']
    if ($event['checked'] == true) {

      document.getElementById(parameter_element_id).classList.replace('invisible', 'visible')

    } else {
      document.getElementById(parameter_element_id).classList.replace('visible', 'invisible')

    }

  }

  prompt_save_commands() {
    //commented ahe 3shan hosny hy2olak user experience...
    this.selected_commands_list = []
    document.querySelectorAll('.mat-checkbox-checked').forEach(item => {
      var command_line = []
      var switcher = 0
      var command_value = document.getElementById('command_value_' + item.id.split('_')[2] + '').textContent
      var command_id_fk = item.id.split('_')[2]
      Object.keys(this.stateGroups).forEach(index => {
        if (this.stateGroups[index]['rec_id'] == command_id_fk) {
          command_line.push(this.stateGroups[index])


        }
      })
      var command_sw_id = command_line['software_version_id']
      var command_syntax = command_line['command_syntax']
      var command_type = command_line['command_parameters_count']
      var command_display = document.getElementById(item.id).textContent
      if (command_value == '' || command_value == null || command_value == undefined) {
        command_value = $('#command_value_' + item.id.split('_')[2] + '').val().toString()

      }
      Object.keys(this.selected_commands_list).forEach(index => {
        if (this.selected_commands_list[index]['command_id_fk'] == command_id_fk) {
          switcher = 1
        }

      })


      if (switcher == 0 || this.selected_commands_list.length == 0) {
        // this.selected_commands_list.push({
        //   added_by: 'test',
        //   command_id_fk: item.id.split('_')[2],
        //   command_is_enabled: 1,
        //   command_sw_version: command_sw_id,
        //   command_type: command_type,
        //   command_syntax: command_syntax,
        //   command_value: command_value,
        //   template_name_id: this.template_id,
        //   event: "create_template_conf"
        // })
        this.openSnackBar('Command was added to the list', '')
        //(this.selected_commands_list)

      } else {
        this.openSnackBar('Command is already in the list', '')

      }
    })
  }

  prompt_save_commands2() {
    //commented ahe 3shan hosny hy2olak user experience...
    this.selected_commands_list = []
    this.stateGroups.forEach(item => {
      var command_value = document.getElementById('command_value_' + item['id']).textContent
      if (command_value == '' || command_value == null || command_value == undefined) {
        command_value = $('#command_value_' + item['id']).val().toString()

      }
      this.selected_commands_list.push({
        added_by: this.user_info_obj["name"],
        command_id_fk: item['id'],
        command_is_enabled: 1,
        command_sw_version: item['software_version_id'],
        command_sw_version_text: item['software_version'],
        command_family: item['command_family'],
        command_type: item['command_parameters_count'],
        command_syntax: item['command_syntax'],
        command_value: command_value,
        template_name_id: this.template_id,
        event: "create_template_conf"
      })
      this.openSnackBar('Command was added to the list', '')

    })
  }

  prompt_save_commands_no_alert() {
    //commented ahe 3shan hosny hy2olak user experience...
    // this.selected_commands_list=[]
    document.querySelectorAll('.mat-checkbox-checked').forEach(item => {
      var command_line = []
      var switcher = 0
      var command_value = document.getElementById('command_value_' + item.id.split('_')[2] + '').textContent
      var command_id_fk = item.id.split('_')[2]

      Object.keys(this.stateGroups).forEach(index => {
        if (this.stateGroups[index]['rec_id'] == command_id_fk) {
          command_line.push(this.stateGroups[index])


        }
      })
      var command_sw_id = command_line[0]['software_version_id']
      var command_syntax = command_line[0]['command_syntax']
      var command_type = command_line[0]['command_parameters_count']
      var command_display = document.getElementById(item.id).textContent
      if (command_value == '' || command_value == null || command_value == undefined) {
        command_value = $('#command_value_' + item.id.split('_')[2] + '').val().toString()

      }
      Object.keys(this.selected_commands_list).forEach(index => {
        if (this.selected_commands_list[index]['command_id_fk'] == command_id_fk) {
          switcher = 1
        }

      })


      if (switcher == 0 || this.selected_commands_list.length == 0) {
        // this.selected_commands_list.push({
        //   added_by: 'test',
        //   command_id_fk: item.id.split('_')[2],
        //   command_is_enabled: 1,
        //   command_sw_version: command_sw_id,
        //   command_type: command_type,
        //   command_syntax: command_syntax,
        //   command_value: command_value,
        //   template_name_id: this.template_id,
        //   event: "create_template_conf"
        // })

      } else {

      }
    })
  }

  prompt_assign_command_to_template() {
    // Object.keys(this.selected_commands_list).forEach(index => {
    //   var command_id = this.selected_commands_list[index]["command_id_fk"]
    //   var command_value = this.selected_commands_list[index]["command_value"]
    //   var command_syntax = this.selected_commands_list[index]["command_syntax"]
    //   var command_sw = this.selected_commands_list[index]["command_sw_version"]
    //   var command_type = this.selected_commands_list[index]["command_type"]
    //   var added_by = this.selected_commands_list[index]["added_by"]
      this.assign_commands_to_template(this.selected_commands_list)
    // })


  }

  delete_from_stateGroups(item: any) {
    var command_id = item.id
    Object.keys(this.stateGroups).forEach(index => {
      if (this.stateGroups[index] != undefined && this.stateGroups[index]['id'] === command_id) {
        this.stateGroups.splice(Number(index), 1)
      }

    })
  }

  delete_from_selected_commands_list(item: any) {
    var command_id = item.command_id_fk
    Object.keys(this.selected_commands_list).forEach(index => {
      if (this.selected_commands_list[index] != undefined && this.selected_commands_list[index]['command_id_fk'] === command_id) {
        this.selected_commands_list.splice(Number(index), 1)
        this.stateGroups.splice(Number(index), 1)
      }

    })
  }

  private _filterGroup(value: string): CommandsGroup[] {
    if (value) {
      return this.stateGroups
        .map(group => ({
          CommandFamily: group.CommandFamily,
          software_id: group.software_id,
          CommandSyntax: group.CommandSyntax,
          CommandType: group.CommandType,
          id: group.id,
          CommandName: _filter(group.CommandName, value)
        }))
        .filter(group => group.CommandName.length > 0);
    }

    return this.stateGroups;

  }

  // end of commands controller
  //end


  formatLabel(value: number) {
    return value;
  }


  deleteTemplate(id: number) {
    this.http.post(template_manager.services, {
      "event": "delete_template_profile_id",
      "id": id
    }).subscribe(data => {
      this.get_distinct_templates();
      this.openSnackBar("Template deleted", "Success")
    }, err => {
      this.loggerService.log("TemplateManagerComponent", err.message, Levels.error)
      this.openSnackBar("Error while deleting template", "Error")
    })
  }
}
